var map = {
	"./Home copy.vue": [
		"d7c2",
		"chunk-2d21f0b8"
	],
	"./Home.vue": [
		"bb51"
	],
	"./Notification.vue": [
		"109a",
		"chunk-49f22c18"
	],
	"./Notifications.vue": [
		"fda7"
	],
	"./Pos.vue": [
		"9a5f"
	],
	"./account_settings/AccountDefaultSettings.vue": [
		"5181",
		"chunk-029f132e"
	],
	"./account_settings/BankAccount.vue": [
		"004b"
	],
	"./account_settings/CostCenter.vue": [
		"dc7b",
		"chunk-2e841745"
	],
	"./account_settings/FiscalYear.vue": [
		"988d",
		"chunk-70355c24"
	],
	"./account_settings/TransactionEntryTypes.vue": [
		"9f8f",
		"chunk-06ea7ad6"
	],
	"./accounts/CustomerCollection.vue": [
		"81e4",
		"chunk-64288a1e"
	],
	"./accounts/PayBills.vue": [
		"9ca6",
		"chunk-04e2639a"
	],
	"./accounts/SupplierLedger.vue": [
		"9539"
	],
	"./accounts/VoucherEntry.vue": [
		"7983",
		"chunk-6b0c95f7"
	],
	"./accounts/VoucherEntryEdit.vue": [
		"ab92"
	],
	"./accounts/VoucherEntryList.vue": [
		"b5198",
		"chunk-f472d658"
	],
	"./coa/AccountClass.vue": [
		"6358",
		"chunk-5d15d798"
	],
	"./coa/AccountLedger.vue": [
		"2d72",
		"chunk-624222fe"
	],
	"./coa/AccountLedgerOld.vue": [
		"3955",
		"chunk-13849858"
	],
	"./coa/AccountType.vue": [
		"a9e0",
		"chunk-1d65b406"
	],
	"./coa/AccountTypeOld.vue": [
		"9082",
		"chunk-085b9469"
	],
	"./coa/ChartOfAccount.vue": [
		"f63d",
		"chunk-f4c50cba"
	],
	"./coa/ChartOfAccountList.vue": [
		"0d12",
		"chunk-2d0af04b"
	],
	"./cogs_account_posting/COGSAccountPosting.vue": [
		"c87e",
		"chunk-3d51cf77"
	],
	"./drawer/Category.vue": [
		"a1b3"
	],
	"./expire_product/ExpiryBoard.vue": [
		"5e98"
	],
	"./helper/Modal.vue": [
		"8bd8"
	],
	"./inventory/InventoryBoard.vue": [
		"a9bf"
	],
	"./menu_and_permissions/ModuleOrMenu.vue": [
		"59bf"
	],
	"./menu_and_permissions/PermissionAction.vue": [
		"5d1c"
	],
	"./page/About.vue": [
		"e3eb",
		"chunk-48c7d09a"
	],
	"./page/Area.vue": [
		"ecc9",
		"chunk-742d1c92"
	],
	"./page/AttributeValue.vue": [
		"c5d8"
	],
	"./page/Attributes.vue": [
		"1ca4"
	],
	"./page/Brand.vue": [
		"92fc"
	],
	"./page/Colors.vue": [
		"7f91"
	],
	"./page/Company.vue": [
		"2299"
	],
	"./page/CompanyAdd.vue": [
		"1940",
		"chunk-2d0ac39a"
	],
	"./page/Conpons.vue": [
		"db46"
	],
	"./page/Customer.vue": [
		"3fb6"
	],
	"./page/CustomerGroup.vue": [
		"5fba"
	],
	"./page/CustomerLedger.vue": [
		"f70e"
	],
	"./page/Department.vue": [
		"f10f"
	],
	"./page/Districts.vue": [
		"8836"
	],
	"./page/Inventory.vue": [
		"8ba1",
		"chunk-6ce344c6"
	],
	"./page/Login.vue": [
		"c36b"
	],
	"./page/MobileWallet.vue": [
		"6942"
	],
	"./page/NumberToWord.vue": [
		"e799"
	],
	"./page/Outlet.vue": [
		"0689"
	],
	"./page/ProductCategory.vue": [
		"f938"
	],
	"./page/Product_List_Item.vue": [
		"7a0f",
		"chunk-2d0e13b6"
	],
	"./page/Role.vue": [
		"d514"
	],
	"./page/RolePermission.vue": [
		"9dba"
	],
	"./page/Sizes.vue": [
		"d44b"
	],
	"./page/Supplier.vue": [
		"a4e2"
	],
	"./page/SupplierType.vue": [
		"e0c6"
	],
	"./page/Taxes.vue": [
		"54ab"
	],
	"./page/Unit.vue": [
		"2fc0"
	],
	"./page/User.vue": [
		"4d7e"
	],
	"./page/Warehouse.vue": [
		"23d6"
	],
	"./pos/Autocomplete.vue": [
		"e96e",
		"chunk-188fe40b"
	],
	"./pos/BackPosLeftbar.vue": [
		"4a9c",
		"chunk-367433f3"
	],
	"./pos/PosLeftbar.vue": [
		"caca"
	],
	"./pos/PosLeftbarBack.vue": [
		"085f",
		"chunk-26989d9d"
	],
	"./pos/PosLeftbarOld.vue": [
		"0446",
		"chunk-91ac8458"
	],
	"./pos/PosLeftbarTestOld.vue": [
		"466c"
	],
	"./pos/PosRightbar.vue": [
		"b634"
	],
	"./pos/Product_List_Item.vue": [
		"65be"
	],
	"./pos_report/CollectionReport.vue": [
		"9790",
		"chunk-3b9074ec"
	],
	"./pos_report/DailySalesReport.vue": [
		"aa25",
		"chunk-783d23f8"
	],
	"./pos_report/DailySummaryReport.vue": [
		"5c5a",
		"chunk-131ce57d"
	],
	"./pos_report/InventoryDetailsReport.vue": [
		"5cef",
		"chunk-8b8308c2"
	],
	"./pos_report/InventorySummary.vue": [
		"05a6",
		"chunk-3e415eca"
	],
	"./pos_report/LowStockReport.vue": [
		"8e89",
		"chunk-0d52f5a8"
	],
	"./pos_report/ProductPurchaseReport.vue": [
		"51fe",
		"chunk-0b89e058"
	],
	"./pos_report/ProductSalesReport.vue": [
		"b6a3",
		"chunk-2abf5032"
	],
	"./pos_report/PurchaseReport.vue": [
		"8d7e",
		"chunk-58777595"
	],
	"./pos_report/SaleReport.vue": [
		"17a0",
		"chunk-cc1a6216"
	],
	"./pos_report/StockReport.vue": [
		"bba0",
		"chunk-59d3f9a3"
	],
	"./product/BarcodeDemo.vue": [
		"2e17"
	],
	"./product/Bulkupload.vue": [
		"25fd"
	],
	"./product/Product.vue": [
		"4ba7"
	],
	"./product/ProductBackup.vue": [
		"2972",
		"chunk-53894b2e"
	],
	"./product/Product_List_Item.vue": [
		"28f6",
		"chunk-2d0b3a4c"
	],
	"./purchase/PurchaseOrder.vue": [
		"d66d"
	],
	"./purchase/PurchaseOrderApprovalList.vue": [
		"aedb"
	],
	"./purchase/PurchaseOrderEdit.vue": [
		"43d2"
	],
	"./purchase/PurchaseOrderList copy.vue": [
		"e2a1",
		"chunk-7f457795"
	],
	"./purchase/PurchaseOrderList.vue": [
		"09ae"
	],
	"./purchase/PurchaseReceive.vue": [
		"6e8e"
	],
	"./purchase/PurchaseReceiveBoard.vue": [
		"3077"
	],
	"./purchase/PurchaseReceiveList.vue": [
		"91fa"
	],
	"./purchase/WarehousePurchaseReceive.vue": [
		"d427"
	],
	"./purchase/WarehousePurchaseReceiveOld.vue": [
		"d4c5",
		"chunk-1fd0d3ee"
	],
	"./purchase_requisition/StorePurchaseRequisition.vue": [
		"d9ad"
	],
	"./purchase_requisition/StorePurchaseRequisitionEdit.vue": [
		"2e47"
	],
	"./purchase_requisition/StoreRequisitionApprovalList.vue": [
		"2ad8"
	],
	"./purchase_requisition/StoreRequisitionList.vue": [
		"bb23"
	],
	"./purchase_requisition/StoreRequisitionPurchaseOrder.vue": [
		"c933"
	],
	"./purchase_requisition/StoreRequisitionPurchaseOrderEdit.vue": [
		"4460"
	],
	"./purchase_return/PurchaseReturn.vue": [
		"f3e3",
		"chunk-8f6dba22"
	],
	"./purchase_return/PurchaseReturnList.vue": [
		"c479",
		"chunk-4c4ffc48"
	],
	"./reports/BalanceSheet.vue": [
		"300f",
		"chunk-85276434"
	],
	"./reports/BankBook.vue": [
		"7250",
		"chunk-0c7ab5bc"
	],
	"./reports/CashAndBankBook.vue": [
		"ad70",
		"chunk-29438dda"
	],
	"./reports/CashBook.vue": [
		"32d9",
		"chunk-3cdd1b16"
	],
	"./reports/DailyTransaction.vue": [
		"d8a5",
		"chunk-2b972bdc"
	],
	"./reports/LedgerReport.vue": [
		"50bd",
		"chunk-66e7c8e8"
	],
	"./reports/ProfitLoss.vue": [
		"47ec",
		"chunk-4fb45134"
	],
	"./reports/TrialBalance.vue": [
		"02ba",
		"chunk-3cf7fc0c"
	],
	"./rewards-points/OrderTatalPoints.vue": [
		"0b0c"
	],
	"./rewards-points/OrderTotalPoints.vue": [
		"7471",
		"chunk-0ea0d0dd"
	],
	"./rewards-points/PointsSettings.vue": [
		"2b57"
	],
	"./rewards-points/RewardsPoints.vue": [
		"1b45a"
	],
	"./sales/DiscountSettings.vue": [
		"9909"
	],
	"./sales/DueSales.vue": [
		"2985",
		"chunk-3055d4ca"
	],
	"./sales/HoldSales.vue": [
		"164c",
		"chunk-e09167b6",
		"chunk-edf664c8"
	],
	"./sales/LoyaltySettings.vue": [
		"f84e",
		"chunk-41e8cc4c"
	],
	"./sales/PosSales.vue": [
		"17cf"
	],
	"./sales/PosSalesOld.vue": [
		"61a9",
		"chunk-50864234"
	],
	"./sales/PosSalesOld2-22.vue": [
		"b189",
		"chunk-345afced"
	],
	"./sales/SalesReturn.vue": [
		"0beb",
		"chunk-e09167b6",
		"chunk-4aee20ec"
	],
	"./sales_account_posting/SalesAccountPosting.vue": [
		"f440",
		"chunk-8631ac04"
	],
	"./settings/GeneralSettings.vue": [
		"1beb",
		"chunk-336b98a6"
	],
	"./stock/DamageProductManagement.vue": [
		"7103",
		"chunk-206795d4"
	],
	"./stock/StockInOut.vue": [
		"70ea"
	],
	"./stock/StockManagement.vue": [
		"bae8"
	],
	"./stock/WarehouseStockManagement.vue": [
		"89b0",
		"chunk-4ca68f95"
	],
	"./stock_transfer/StockTransfer.vue": [
		"c895"
	],
	"./stock_transfer/StockTransferList.vue": [
		"4642"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;